import html2canvas from "html2canvas"
import { PDFHeader } from "../PDFHeader"
import { PDFFooter } from "../PDFFooter"
import "jspdf-autotable"

export const generateTopLocationsPDF = async ({
  pdf,
  corporateData,
  locationChartData,
  topLocationsRef,
  locationName = "Current Location"
}) => {

  const element = topLocationsRef?.current
  if (!element) return

  const startY = await PDFHeader({ pdf, corporateData })

  pdf.setFontSize(14)
  pdf.setFont(undefined, "bold")
  pdf.text(`Top 10 location (${locationName})`, 15, startY)

  pdf.setFontSize(10)
  pdf.setFont(undefined, "normal")
  pdf.text(
    "Data below shows the indication of company location by the amount spent",
    15,
    startY + 6
  )

  const chartElement = element.querySelector("canvas")?.parentNode?.parentNode

  const canvas = await html2canvas(chartElement, {
    scale: 2,
    useCORS: true,
  })

  const imgData = canvas.toDataURL("image/png")

  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  const maxImgWidth = Math.min(200, pageWidth - 30)
  const maxImgHeight = pageHeight * 0.40

  let imgWidth = maxImgWidth
  let imgHeight = (canvas.height * imgWidth) / canvas.width

  if (imgHeight > maxImgHeight) {
    imgHeight = maxImgHeight
    imgWidth = (canvas.width * imgHeight) / canvas.height
  }

  pdf.addImage(imgData, "PNG", 15, startY + 12, imgWidth, imgHeight)

  let currentY = startY + 12 + imgHeight + 10

  const locationBarData = locationChartData?.locationBarChart || []

  const validLocations = locationBarData.filter(
    item => item.location && item.location !== ""
  )

  let legendY = currentY - 5

  // ✅ Increase text size
  pdf.setFontSize(13) // was 11
  pdf.setFont(undefined, "bold")
  pdf.setTextColor(26, 38, 69)

  // Move text slightly down for better alignment
  pdf.text("Hires", 25, legendY)

  // ✅ Lift line slightly up
  const lineY = legendY - 1.5

  // ✅ Decrease line thickness
  pdf.setDrawColor(209, 209, 209)
  pdf.setLineWidth(0.2) // was 0.5

  // Adjust start position so it aligns nicely with text
  pdf.line(45, lineY, pdf.internal.pageSize.getWidth() - 15, lineY)

  const tableData = validLocations.slice(0, 10).map(item => {

    const genderAnalysis = item.locationGenderAnalysis || {}
    const men = genderAnalysis.men || 0
    const women = genderAnalysis.women || 0
    const others = genderAnalysis.others || 0

    return [
      item.location || "Unknown",
      item.hired || 0,
      `Men: ${men}`,
      `Women: ${women}`,
      `Others: ${others}`
    ]
  })

  pdf.autoTable({
    startY: currentY,
    head: [["Cities", "Hires", "Gender", "", ""]],
    body: tableData,
    theme: "grid",
    styles: { fontSize: 10 },
    headStyles: {
      fillColor: [220, 220, 220],
      textColor: 0,
      fontStyle: "bold",
    },

    didParseCell: function (data) {
      if (data.column.index >= 2) {
        data.cell.styles.cellPadding = { left: 7, top: 2, bottom: 2 }
      }
    },

    didDrawCell: function (data) {

      if (data.column.index >= 2 && data.cell.section === "body") {

        const { x, y, height } = data.cell
        const text = data.cell.raw

        const circleX = x + 3
        const circleY = y + height / 2
        const radius = 1

        if (text.startsWith("Men")) {
          pdf.setFillColor(0, 27, 72)
          pdf.circle(circleX, circleY, radius, "F")
        }

        if (text.startsWith("Women")) {
          pdf.setFillColor(1, 138, 190)
          pdf.circle(circleX, circleY, radius, "F")
        }

        if (text?.startsWith("Others")) {
          pdf.setFillColor(200, 200, 200) // #C8C8C8
          pdf.circle(circleX, circleY, radius, "F")
        }
      }
    }
  })

  await PDFFooter({ pdf })
}